import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { getApiError } from "@/lib/api";

const Login = () => {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("OK");
      navigate("/valutazione");
    } catch (err) {
      toast.error(getApiError(err, t.auth.error_login));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="login-page" className="min-h-[calc(100vh-64px)] bg-grid">
      <div className="max-w-md mx-auto px-6 py-20">
        <span className="overline text-[#002FA7]">AUTH / LOGIN</span>
        <h1 className="font-display font-black text-5xl tracking-tighter mt-2">{t.auth.login_title}</h1>

        <form onSubmit={submit} className="mt-10 bg-white border border-black p-8 shadow-hard space-y-5">
          <div>
            <label className="label-rv">{t.auth.email}</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-rv" />
          </div>
          <div>
            <label className="label-rv">{t.auth.password}</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-rv" />
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "..." : t.auth.submit_login}
          </button>
          <p className="text-sm text-[#4A4A4A] text-center">
            {t.auth.no_account} <Link to="/signup" className="font-bold underline">{t.auth.go_signup}</Link>
          </p>
        </form>
      </div>
    </main>
  );
};

export default Login;
